import { atom, useAtomValue, useSetAtom } from 'jotai';
import { Domaine, Item, Matiere } from 'types/programmations';

interface Payload {
  onSelect?: (
    item: Item,
    matiere: Matiere,
    domaine: Domaine,
    progId: string,
    doNotPrefillFdp?: boolean,
  ) => Promise<any>;
  callback?: (
    item: Item,
    matiere: Matiere,
    domaine: Domaine,
    progId: string,
    doNotPrefillFdp?: boolean,
  ) => void;
  matiereName?: string;
  domaineName?: string;
  date?: Date;
  callout?: string;
  isOpen: boolean;
}

export const payload = atom<Payload>({
  isOpen: false,
});

const isOpenAtom = atom(get => get(payload)?.isOpen);
export const useIsProgItemDrawerOpen = () => useAtomValue<boolean>(isOpenAtom);

export const useProgItemPayload = () => useAtomValue(payload);
export const useSetProgItemPayload = () => useSetAtom(payload);
const close = atom(null, (get, set) => {
  set(payload, { ...get(payload), isOpen: false });
});
const open = atom(null, (get, set, params?: Payload) => {
  if (params) {
    set(payload, { ...get(payload), ...params });
  }
  set(payload, { ...get(payload), isOpen: true });
});
export const useCloseProgItemDrawer = () => useSetAtom(close);
export const useOpenProgItemDrawer = () => useSetAtom(open);
